import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "playlistId", "onSuccess", "showNotification", "onClick", "use", "item", "playlistName"];
import getLang from 'LearningCenterUI/utils/getLang';
import Raven from 'raven-js';
import { Button } from 'foundations-components/transitional/components/Button';
import { useRemoveFromPlaylist } from '../../savedItems/savedItemsQueries';
import FormattedMessage from 'I18n/components/FormattedMessage';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import I18n from 'I18n';
import { useCatalogCardModels } from 'academy-common-lib/features/catalog/hooks/useCatalogCardModels';
import { getPlaylistUrl } from '../../playlist/playlistRouting';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { toPlaylistItemType } from '../../playlistItems/playlistItemsTypes';
import { convertToSupportedLanguage } from 'academy-common-lib/constants/academySupportedLanguages';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RemoveItemFromPlaylistSuccessNotification = ({
  item,
  playlistName,
  playlistId
}) => {
  var _catalogCardModels$;
  // needs to retrieve the card model for the name
  // will be removed after migration
  const {
    catalogCardModels
  } = useCatalogCardModels({
    items: [item]
  });
  const itemName = (catalogCardModels === null || catalogCardModels === void 0 || (_catalogCardModels$ = catalogCardModels[0]) === null || _catalogCardModels$ === void 0 ? void 0 : _catalogCardModels$.name) || '';
  return /*#__PURE__*/_jsxs(ButtonWrapper, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.savedItems.tooltips.removedFromPlaylist",
      options: {
        itemName,
        playlistName
      }
    }), /*#__PURE__*/_jsx(RouterButton, {
      marginInlineStart: "400",
      size: "small",
      to: getPlaylistUrl(playlistId),
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.savedItems.tooltips.viewPlaylist"
      })
    })]
  });
};
const RemoveItemFromPlaylistButton = _ref => {
  let {
      children,
      playlistId,
      onSuccess,
      showNotification = true,
      onClick,
      use = 'unstyled',
      item,
      playlistName
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [removeFromPlaylist, {
    removeFromPlaylistMutationLoading
  }] = useRemoveFromPlaylist();
  const handleOnClick = e => {
    if (removeFromPlaylistMutationLoading) return;
    if (onClick) onClick(e);
    const playlistItemType = toPlaylistItemType(item.type);
    if (!playlistItemType) {
      // this should never happen
      Raven.captureMessage('Content type cannot be removed from playlist', {
        extra: {
          item
        }
      });
      return;
    }
    removeFromPlaylist({
      playlistId,
      itemId: item.id,
      language: convertToSupportedLanguage(item.language),
      type: playlistItemType
    }).then(() => {
      if (showNotification) {
        FloatingAlertStore.addAlert({
          message: /*#__PURE__*/_jsx(RemoveItemFromPlaylistSuccessNotification, {
            item: item,
            playlistId: playlistId,
            playlistName: playlistName
          }),
          type: 'success'
        });
      }
      onSuccess === null || onSuccess === void 0 || onSuccess();
    }).catch(() => {
      if (showNotification) {
        FloatingAlertStore.addAlert({
          message: I18n.text('learningCenter.savedItems.tooltips.removeFromPlaylistError'),
          type: 'danger'
        });
      }
      Raven.captureMessage(`Achievements: error removing item from playlist`, {
        extra: {
          playlistId,
          itemId: item.id,
          language: item.language || getLang(),
          type: item.type
        }
      });
    });
  };
  return /*#__PURE__*/_jsx(Button, Object.assign({}, buttonProps, {
    onClick: handleOnClick,
    use: use,
    children: children
  }));
};
export default RemoveItemFromPlaylistButton;